import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b8378d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "projects-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "project-item__info project-info" }
const _hoisted_4 = { class: "project-info__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: p.project_id,
        class: "projects-wrapper__item project-item",
        to: `/projects/${p.project_id}`
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: p.images[0],
            alt: "Изборажение проекта"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(p.info.name), 1),
            _createVNode(_component_AppButton, {
              to: `/projects/${p.project_id}`
            }, {
              default: _withCtx(() => [
                _createTextVNode("Смотреть")
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
}